import { useState } from "react";
import TextField from '@mui/material/TextField';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Button, Stack, Select, MenuItem } from "@mui/material";


function getUnixTimeStamp(date) {
    return Math.floor(date.getTime()/1000);
}

function SearchForm1({ submitCallback }) {


    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [type, setType] = useState('cumulative');

    function clickedCallback() {
        if (startDate === null || endDate === null) {
            return;
        }

        if (startDate.getTime() > endDate.getTime()) {
            alert("Start date should be before End date");
            return;
        }

        // let s = { startDate: getUnixTimeStamp(startDate), endDate: getUnixTimeStamp(endDate) };
        let s = { startDate: (startDate), endDate: (endDate), type };
        // console.log(s);
        submitCallback(s);
    }

    function handleSetEndDate(date) {
        if(date) {
            date.setHours(23, 59, 59);
        }
        setEndDate(date)
    }


    return (<>

    <Box sx={{padding: '20px 60px', border: '1px solid #eee'}}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={{xs: 3, md: 6}} justifyContent='center' alignItems='center'>
                <DatePicker
                label="Start Date"
                    value={startDate}
                onChange={(newValue) => {
                    setStartDate(newValue);
                }}
                format="dd/MM/yyyy"
                
                renderInput={(params) => <TextField {...params} />}/>

                <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={(newValue) => {
                        handleSetEndDate(newValue);
                    }}
                    format="dd/MM/yyyy"
                    renderInput={(params) => <TextField {...params} />}/>

                <Select onChange={e => setType(e.target.value)}
                    value={type}>
                    <MenuItem value={'cumulative'}>Cumulative</MenuItem>
                    <MenuItem value={'datewise'}>DateWise</MenuItem>
                </Select>

                <Button variant="outlined" onClick={clickedCallback}>Search</Button>
        </Stack>

    </Box>

    </>);
}

export default SearchForm1;
